"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerPagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _ServerPagination = require("./ServerPagination.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerPagination = function ServerPagination(_ref) {
  var handleChangePerPage = _ref.handleChangePerPage,
      perPage = _ref.perPage,
      page = _ref.page,
      handleChangePage = _ref.handleChangePage,
      loading = _ref.loading,
      data = _ref.data,
      totalRecords = _ref.totalRecords;

  var labelDisplayedRows = function labelDisplayedRows(_ref2) {
    var from = _ref2.from,
        to = _ref2.to;
    return "".concat(from, "-").concat(to, " of ").concat(totalRecords);
  };

  return /*#__PURE__*/_react.default.createElement(_ServerPagination.ServerPaginationView, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "server-pagination"
  }, /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    component: "div",
    count: -1,
    page: page,
    onChangePage: handleChangePage,
    rowsPerPage: perPage,
    onChangeRowsPerPage: handleChangePerPage,
    nextIconButtonProps: {
      disabled: data.length < perPage || loading
    },
    backIconButtonProps: {
      disabled: !data.length || loading || page === 0
    },
    labelDisplayedRows: labelDisplayedRows
  })));
};

exports.ServerPagination = ServerPagination;

//# sourceMappingURL=ServerPagination.js.map